import axios, { AxiosError } from 'axios';
import Environment from '../../utils/Environment';

interface ErrorResponse {
  error: string;
  status?: number;
}

const getDcNames = async (): Promise<string[] | ErrorResponse> => {
  const apiUrl = Environment.getStoreOrderDcNamesAPI();

  try {
    const { data } = await axios.get<string[]>(apiUrl);
    return data;
  } catch (err) {
    const error = err as AxiosError;
    const message = error.response?.data || error.message || 'Unknown error';

    return {
      error: typeof message === 'string' ? message : JSON.stringify(message),
      status: error.response?.status,
    };
  }
};

export default getDcNames;